// 'use client'

// import Cookies from 'js-cookie'
// import { useEffect, useState } from 'react'

// type AuthStatus = 'authenticated' | 'unauthenticated' | 'loading'

// /**
//  * Client-side hook to check authentication status using cookies
//  * Replaces the status checking functionality from useSession
//  */
// export function useAuthStatus(): AuthStatus {
//   const [status, setStatus] = useState<AuthStatus>('loading')

//   useEffect(() => {
//     const checkAuthStatus = () => {
//       const sessionCookie = Cookies.get('ZAMPLY_SESSION')
//       const expiresAtCookie = Cookies.get('ZAMPLY_SESSION_EXPIRES_AT')

//       console.log({sessionCookie, expiresAtCookie})

//       if (!sessionCookie || !expiresAtCookie) {
//         setStatus('unauthenticated')
//         return
//       }

//       const expiresAt = new Date(expiresAtCookie)
//       const now = new Date()

//       if (now >= expiresAt) {
//         setStatus('unauthenticated')
//         // Clean up expired cookies
//         Cookies.remove('ZAMPLY_SESSION')
//         Cookies.remove('ZAMPLY_SESSION_EXPIRES_AT')
//         return
//       }

//       setStatus('authenticated')
//     }

//     // Initial check
//     checkAuthStatus()

//     // Set up interval to check expiration
//     const interval = setInterval(checkAuthStatus, 5000)

//     // Listen for cookie changes (for cross-tab synchronization)
//     const handleStorageChange = (e: StorageEvent) => {
//       if (e.key === 'ZAMPLY_SESSION' || e.key === 'ZAMPLY_SESSION_EXPIRES_AT') {
//         checkAuthStatus()
//       }
//     }

//     window.addEventListener('storage', handleStorageChange)

//     return () => {
//       clearInterval(interval)
//       window.removeEventListener('storage', handleStorageChange)
//     }
//   }, [])

//   return status
// }

// /**
//  * Simple hook to check if user is authenticated (boolean)
//  */
// export function useIsAuthenticated(): boolean {
//   const status = useAuthStatus()
//   return status === 'authenticated'
// }

'use client'

export { useAuthStatus, useIsAuthenticated } from '@/contexts/auth-context'
